export const SET_WRONG_NETWORK = 'SET_WRONG_NETWORK';
